import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {ContactCompanyFilter} from "./contactCompany.filter";
import { debounceTime } from 'rxjs/operators';
import {SettingsPersistenceService} from "../services/settings-persistence.service";

@Component({
  selector: 'micro-contactCompanies',
  templateUrl: './contactCompanies.component.html'
})
export class ContactCompaniesComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns:string[] = ['name'];
  filter:ContactCompanyFilter = new ContactCompanyFilter();
  isCompanyAdmin:boolean = false;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnInit() {

    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.contactCompanies");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .init();

    this.isCompanyAdmin = this.auth.isCompanyAdmin();
    if (this.isCompanyAdmin) {
      this.filter.companyId = this.auth.companyIdFilter;
    }

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
      .set("page", '' + (this.paginator.pageIndex || 0))
      .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
    ;

    this.http.get(`${this.env.e.url}/auth/contactCompanies`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
